import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import "./Layanan.css";
import { useNavigate } from "react-router-dom";
import service1 from "../assets/Pruning.jpeg";
import service2 from "../assets/Nursery.jpeg";
import service3 from "../assets/Replanting.jpeg";
import testimonialFallback from "../assets/Background.jpeg";

export default function Layanan() {
  const navigate = useNavigate();
  const envApi = process.env.REACT_APP_API_URL || "/api";
  const currentOrigin = typeof window !== "undefined" ? window.location.origin : "";
  const isLocalWeb =
    typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
  const apiUrl = (() => {
    const raw = String(envApi || "").trim();
    if (!/^https?:\/\//i.test(raw)) return raw || "/api";
    try {
      const u = new URL(raw);
      const isLocalApi = /^(localhost|127\.0\.0\.1)$/i.test(u.hostname);
      if (!isLocalWeb && isLocalApi) return `${currentOrigin}/api`;
      if (typeof window !== "undefined" && window.location.protocol === "https:" && u.protocol === "http:") {
        return raw.replace(/^http:/i, "https:");
      }
      return raw;
    } catch {
      return raw || "/api";
    }
  })();
  const apiOrigin = apiUrl.startsWith("http")
    ? apiUrl.replace(/\/api\/?$/, "")
    : (currentOrigin || "");
  const uploadBase = apiOrigin || "/api";

  const [testimonials, setTestimonials] = useState([]);
  const [loadingTestimonials, setLoadingTestimonials] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [photoPreview, setPhotoPreview] = useState("");
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [serviceIndex, setServiceIndex] = useState(0);
  const [form, setForm] = useState({
    name: "",
    origin: "",
    message: "",
    photo: null,
  });

  const handleRedirect = () => {
    navigate("/agriservis");
  };

  const services = useMemo(
    () => [
      {
        id: 1,
        image: service1,
        alt: "Jasa Servis",
        title: "Jasa Peremajaan & Pemeliharaan Kebun Kakao",
        desc:
          "Sahabat Kakao menyediakan jasa peremajaan dan pemeliharaan kebun kakao menggunakan teknologi terbaru, seperti sambung samping, pemangkasan, pengendalian H&P, perkawinan bunga, dan lainnya.",
      },
      {
        id: 2,
        image: service2,
        alt: "Bahan Tanam Unggul",
        title: "Akses Clone (Bahan Tanam) Unggul",
        desc:
          "Sahabat Kakao menyediakan akses bagi Anda untuk mendapatkan clone (bahan tanam) kakao unggul untuk meningkatkan produktivitas kebun.",
      },
      {
        id: 3,
        image: service3,
        alt: "Bahan Input",
        title: "Akses ke Bahan Input",
        desc:
          "Sahabat Kakao menyediakan akses ke bahan input yang ramah lingkungan untuk mendukung pertanian berkelanjutan.",
      },
    ],
    []
  );

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${apiUrl}/testimonials/public`)
      .then((res) => {
        if (!mounted) return;
        setTestimonials(Array.isArray(res?.data?.data) ? res.data.data : []);
      })
      .catch(() => {
        if (!mounted) return;
        setTestimonials([]);
      })
      .finally(() => {
        if (mounted) setLoadingTestimonials(false);
      });
    return () => {
      mounted = false;
    };
  }, [apiUrl]);

  useEffect(() => {
    if (testimonials.length <= 1) return undefined;
    const timer = setInterval(() => {
      setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [testimonials]);

  useEffect(() => {
    if (services.length <= 1) return undefined;
    const timer = setInterval(() => {
      setServiceIndex((prev) => (prev + 1) % services.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [services]);

  useEffect(() => {
    return () => {
      if (photoPreview) URL.revokeObjectURL(photoPreview);
    };
  }, [photoPreview]);

  const testimonialCount = useMemo(() => testimonials.length, [testimonials]);
  const activeTestimonial =
    testimonials.length > 0 ? testimonials[testimonialIndex % testimonials.length] : null;
  const activeService = services[serviceIndex % services.length];

  const resolvePhotoUrl = (url) => {
    const raw = String(url || "").trim();
    if (!raw) return "";
    if (raw.startsWith("blob:")) return "";
    if (raw.startsWith("data:")) return raw;
    if (/^https?:\/\//i.test(raw)) {
      try {
        const u = new URL(raw);
        const isLocalHostUrl = /^(localhost|127\.0\.0\.1)$/i.test(u.hostname);
        if (isLocalHostUrl && u.pathname.startsWith("/uploads/")) {
          return `${currentOrigin}${u.pathname}`;
        }
        if (u.pathname.startsWith("/uploads/")) {
          return `${uploadBase}${u.pathname}`;
        }
      } catch {
        return raw;
      }
      return raw;
    }
    if (raw.startsWith("/uploads/")) return `${uploadBase}${raw}`;
    if (raw.startsWith("/")) return apiOrigin ? `${apiOrigin}${raw}` : raw;
    return apiOrigin ? `${apiOrigin}/${raw}` : raw;
  };

  const submitTestimonial = async (e) => {
    e.preventDefault();
    if (submitting) return;

    if (!form.name.trim() || !form.message.trim() || !form.photo) {
      alert("Nama, testimoni, dan foto wajib diisi.");
      return;
    }

    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("name", form.name.trim());
      fd.append("origin", form.origin.trim());
      fd.append("message", form.message.trim());
      fd.append("photo", form.photo);

      const res = await axios.post(`${apiUrl}/testimonials`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res?.data?.success) {
        alert("Testimoni terkirim. Admin akan meninjau terlebih dahulu sebelum ditampilkan.");
        setForm({ name: "", origin: "", message: "", photo: null });
        if (photoPreview) {
          URL.revokeObjectURL(photoPreview);
          setPhotoPreview("");
        }
        setShowModal(false);
      } else {
        alert(res?.data?.message || "Gagal mengirim testimoni.");
      }
    } catch (err) {
      alert(err?.response?.data?.message || "Gagal mengirim testimoni.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="layanan-container">
      <div className="layanan-two-col">
        <section className="layanan-section layanan-testimoni">
          <div className="section-head">
            <div>
              <h1>Testimoni Petani</h1>
              <p>Ceritakan pengalaman Anda tentang Sahabat Kakao!</p>
            </div>
            <div className="section-actions">
              <span className="testimonial-count">{testimonialCount} Testimoni Tayang</span>
              <button className="btn-primary" onClick={() => setShowModal(true)}>
                Berikan Testimoni
              </button>
            </div>
          </div>

          {loadingTestimonials ? (
            <div className="empty-testimonial">Memuat testimoni...</div>
          ) : !activeTestimonial ? (
            <div className="empty-testimonial">
              Belum ada testimoni yang ditampilkan. Jadilah yang pertama mengirim testimoni Anda.
            </div>
          ) : (
            <div className="carousel-pane">
              <article className="testimonial-card">
                <img
                  src={resolvePhotoUrl(activeTestimonial.photo_url)}
                  alt={activeTestimonial.name}
                  onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src = testimonialFallback;
                  }}
                />
                <div className="card-overlay testimonial-overlay">
                  <h3>{activeTestimonial.name}</h3>
                  <span>{activeTestimonial.origin || "Petani Kakao"}</span>
                  <p>{activeTestimonial.message}</p>
                </div>
              </article>
              <div className="carousel-dots">
                {testimonials.map((item, idx) => (
                  <button
                    key={item.id}
                    type="button"
                    className={idx === (testimonialIndex % testimonials.length) ? "active" : ""}
                    onClick={() => setTestimonialIndex(idx)}
                    aria-label={`Testimoni ${idx + 1}`}
                  />
                ))}
              </div>
            </div>
          )}
        </section>

        <section className="layanan-section layanan-jenis">
          <div className="section-head">
            <div>
              <h2>Jenis Layanan Sahabat Kakao</h2>
              <p>Pilih layanan yang paling sesuai dengan kebutuhan kebun Anda.</p>
            </div>
          </div>

          <div className="carousel-pane">
            <article className="service-card">
              <img src={activeService.image} alt={activeService.alt} />
              <div className="card-overlay service-overlay">
                <h3>{activeService.title}</h3>
                <p>{activeService.desc}</p>
                <button onClick={handleRedirect}>Berminat?</button>
              </div>
            </article>
            <div className="carousel-dots">
              {services.map((item, idx) => (
                <button
                  key={item.id}
                  type="button"
                  className={idx === (serviceIndex % services.length) ? "active" : ""}
                  onClick={() => setServiceIndex(idx)}
                  aria-label={`Layanan ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </section>
      </div>

      {showModal && (
        <div
          className="testimoni-modal-backdrop"
          onClick={() => {
            if (photoPreview) {
              URL.revokeObjectURL(photoPreview);
              setPhotoPreview("");
            }
            setShowModal(false);
          }}
        >
          <div className="testimoni-modal" onClick={(e) => e.stopPropagation()}>
            <div className="testimoni-modal-head">
              <h3>Berikan Testimoni</h3>
              <button
                type="button"
                className="modal-close"
                onClick={() => {
                  if (photoPreview) {
                    URL.revokeObjectURL(photoPreview);
                    setPhotoPreview("");
                  }
                  setShowModal(false);
                }}
                aria-label="Tutup"
              >
                x
              </button>
            </div>

            <form className="testimoni-form" onSubmit={submitTestimonial}>
              <label>
                Nama
                <input
                  value={form.name}
                  onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                  placeholder="Masukkan nama"
                  required
                />
              </label>

              <label>
                Asal (Desa/Kecamatan/Kabupaten)
                <input
                  value={form.origin}
                  onChange={(e) => setForm((p) => ({ ...p, origin: e.target.value }))}
                  placeholder="Contoh: Desa A, Kec. B, Kab. C"
                />
              </label>

              <label>
                Testimoni
                <textarea
                  value={form.message}
                  onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))}
                  placeholder="Bagikan pengalaman Anda menggunakan layanan Sahabat Kakao"
                  rows={4}
                  required
                />
              </label>

              <label>
                Foto
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const f = e.target.files?.[0] || null;
                    setForm((p) => ({ ...p, photo: f }));
                    if (photoPreview) URL.revokeObjectURL(photoPreview);
                    setPhotoPreview(f ? URL.createObjectURL(f) : "");
                  }}
                  required
                />
              </label>

              {photoPreview && (
                <div className="testimoni-photo-preview">
                  <img src={photoPreview} alt="Preview testimoni" />
                </div>
              )}

              <div className="testimoni-form-actions">
                <button
                  type="button"
                  className="btn-light"
                  onClick={() => {
                    if (photoPreview) {
                      URL.revokeObjectURL(photoPreview);
                      setPhotoPreview("");
                    }
                    setShowModal(false);
                  }}
                >
                  Batal
                </button>
                <button type="submit" className="btn-primary" disabled={submitting}>
                  {submitting ? "Mengirim..." : "Kirim Testimoni"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

